import { Link2, Linkedin, Mail } from "lucide-react";
import { toast } from "@/components/ui/sonner";

// X (Twitter) does not ship a Lucide icon, so use a small inline glyph.
function XIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={15} height={15} fill="currentColor" {...props}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function ShareButtons({ title, className = "", testIdPrefix = "newsletter-share" }) {
  const url = typeof window !== "undefined" ? window.location.href : "";

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Couldn't copy the link. Try selecting it manually.");
    }
  };

  const shareLinks = [
    {
      key: "x",
      label: "Share on X",
      icon: XIcon,
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
    },
    {
      key: "linkedin",
      label: "Share on LinkedIn",
      icon: Linkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    },
    {
      key: "email",
      label: "Share by email",
      icon: Mail,
      href: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`,
    },
  ];

  return (
    <div data-testid={testIdPrefix} className={`flex items-center gap-2 ${className}`}>
      <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-500 mr-1">Share</span>
      <button
        onClick={copyLink}
        data-testid={`${testIdPrefix}-copy-link`}
        aria-label="Copy link"
        className="w-9 h-9 rounded-full border border-zinc-800 flex items-center justify-center text-zinc-400 hover:text-accent hover:border-accent/50 transition-colors"
      >
        <Link2 size={15} />
      </button>
      {shareLinks.map(({ key, label, icon: Icon, href }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testIdPrefix}-${key}`}
          aria-label={label}
          className="w-9 h-9 rounded-full border border-zinc-800 flex items-center justify-center text-zinc-400 hover:text-accent hover:border-accent/50 transition-colors"
        >
          <Icon size={15} />
        </a>
      ))}
    </div>
  );
}
